<template>
   <a id="tslink" :href="url()" target="_blank">
      TECH SUPPORT
   </a>
</template>
<script>
export default {
   data() {
      return {
         baseurl: "https://ww2.manhattanlife.com/techsupport/?user=[USR]&ref=[REF]&app=33&addinfo=PleaseHelp",
         theref: 'https://easyappoint.manhattanlife.com',
         username: this.$store.getters.appUser != null ? this.$store.getters.appUser.userName : null,
      }
   },
   methods: {
      url() {
         var tsurl = this.baseurl.replace("[USR]", encodeURIComponent(this.username)).replace("[REF]", encodeURIComponent(this.theref));
         return tsurl
      },
   }
}
</script>
<style scoped lang="scss">
@import '../assets/css/colors.scss';

#tslink {
   align-self: flex-end;
   text-align: center;
   border: 1px solid $corp-color;
   border-top-width: 0;
   border-right-width: 0;
   border-bottom-width: 0;
   background-color: #000;
   color: $corp-color;
   width: 160px;
   font-size: larger;
   padding: 0 12px;
}

#tslink:hover {
   border-width: 0px;
   background-color: $corp-color;
   color: #000;
}
</style>